import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { HosdocService } from '../../hosdoc-service/hosdoc.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-hosdocprofile',
  templateUrl: './hosdocprofile.component.html',
  styleUrls: ['./hosdocprofile.component.css']
})
export class HosdocprofileComponent implements OnInit {
  id: any;
  isAppointment=false
docData
  constructor(private authService:AuthService,private hospitalDocService:HosdocService,private activatedRoute:ActivatedRoute) { }

  ngOnInit() {
this.id=this.activatedRoute.snapshot.queryParams['id']
this.getSingleDoc()  
}
  getSingleDoc() {
this.hospitalDocService.getSingleDoctorFromDb(this.id,"").subscribe(res=>{
  this.docData=res
})
  }


}
